import React from 'react'
import { Grid, Button, Typography, makeStyles } from '@material-ui/core'
import TRANSLATE from 'utils/constants'

const useStyles = makeStyles(theme => ({
   toolbarContainer: {
      padding: theme.spacing(2, 2, 0),
      borderTop: '4px solid #3264DC',
      justifyContent: 'space-between'
   },
   titleTable: {
      textAlign: 'left',
      fontSize: 14,
      fontWeight: 'bold'
   },
   subTitleTable: {
      textAlign: 'left',
      fontSize: 12
   },
   cleanButton: {
      color: '#3264DC',
      border: '1px solid #3264DC',
      fontWeight: 'bold'
   }
}))

const TableToolbar = ({ cleanCallback, totalRows, toolbarTitle, ToolbarComponents }) => {
   const classes = useStyles()

   return (
      <Grid container className={classes.toolbarContainer}>
         <Grid>
            <Typography className={classes.titleTable}>
               {toolbarTitle || TRANSLATE.LABELS.SEARCH_RESULTS}
            </Typography>
            <Typography className={classes.subTitleTable}>
               {totalRows} total
            </Typography>
         </Grid>
         <Grid>
            {
               ToolbarComponents ||
               <Button
                  classes={{
                     root: classes.cleanButton
                  }}
                  variant="outlined"
                  onClick={cleanCallback}
               >
                  {TRANSLATE.BUTTONS.CLEAN}
               </Button>
            }
         </Grid>
      </Grid>
   )
}

export default TableToolbar
